import { ControlForm, Modal } from "../../../components";
import { TagInput } from "../../WorkflowManagement/components/TagInput/TagInput";
import useAxios from "../../../components/UseAxios/useAxios";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toggleMessage } from "../../../components/Toast/Toast";

import * as Yup from "yup";
import InputForm from "../../../components/controls/InputForm";
import WorkflowService from "../../../services/api/workflow.service";
import { ICopyWorkflowRequest } from "../../../models/workflow";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  handleSuccess: () => void;
  handleClose: () => void;
  workflowId: string;
}
interface DataForm {
  name: string;
  type: string;
}

const CopyWorkflowModal = ({
  open,
  workflowId,
  handleSuccess,
  handleClose
}: Props) => {
  const copyWorkflowAxios = useAxios<string>({ loading: "OnRequest" });
  const { t } = useTranslation();

  useEffect(() => {
    reset();
  }, [open]);

  useEffect(() => {
    if (copyWorkflowAxios.error)
      toggleMessage({
        type: "error",
        message: copyWorkflowAxios.error?.message ?? ""
      });
    if (copyWorkflowAxios.isSuccess) {
      toggleMessage({
        type: "success",
        message: copyWorkflowAxios.message ?? ""
      });
      handleSuccess();
      handleClose();
    }
  }, [copyWorkflowAxios.error, copyWorkflowAxios.isSuccess]);

  const onSubmit = async (data: DataForm) => {
    const request: ICopyWorkflowRequest = {
      Id: workflowId,
      Name: data.name,
      TypeBoard: data.type
    };

    copyWorkflowAxios.request(WorkflowService.copyWorkflow(request));
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(t("Management.PleaseEnterTheWorkflowName")),
    type: Yup.string()
      .trim()
      .required(t("Management.PleaseEnterTheWorkflowCategoryName"))
  }) as any;
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<DataForm>({
    resolver: yupResolver(validationSchema)
  });

  return (
    <Modal
      title={t("Management.DuplicateNewWorkflow")}
      textSubmit={t("Modal.SubmitText")}
      textClose={t("Modal.CancelText")}
      open={open}
      onSubmit={handleSubmit(onSubmit)}
      loadingState={copyWorkflowAxios.isLoading}
      disabledSubmit={copyWorkflowAxios.isLoading}
      onClose={
        !copyWorkflowAxios.isLoading
          ? () => {
              handleClose();
            }
          : undefined
      }
      width="500px"
    >
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <ControlForm
          title={t("Management.NewWorkflowName")}
          classname="brand-form"
          children={
            <InputForm
              placeholder={t("Management.NewWorkflowName")}
              name="name"
              errors={errors}
              control={control}
              required
              size="small"
            />
          }
        />
        <ControlForm
          title={t("Management.WorkflowCategory")}
          classname="brand-form"
          children={
            <InputForm
              placeholder={t("Management.WorkflowCategory")}
              name="type"
              errors={errors}
              control={control}
              required
              size="small"
            />
          }
        />
      </form>
    </Modal>
  );
};

export default CopyWorkflowModal;
